export enum MainActionType {
  FETCH_CONFIG = 'FETCH_CONFIG',
  FETCH_HOLIDAYS_CONFIG = 'FETCH_HOLIDAYS_CONFIG',
  FETCH_PERMISSIONS = 'FETCH_PERMISSIONS',
  FETCH_ORDERABLE_UNITS_CONFIG = 'FETCH_ORDERABLE_UNITS_CONFIG'
}
